<template>
  <div class="projectPage">
    <Header
      :menuIndex="2"
      :banner="bannerImg"
      mainTitle="工程行业解决方案"
      subTitle="助力企业高效运维"
    />
    <div class="navBar">
      <div class="container">
        <div
          class="item"
          v-for="(item, index) in navBarList"
          :key="index"
          :class="{ active: activeIndex == index }"
          @click="changeActiveIndex(index)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="container" ref="sectionA">
      <section class="sectionA">
        <div class="sec-title">{{ navBarList[0] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionAList" :key="index">
            <img :src="item.img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </section>
    </div>
    <section class="sectionB" ref="sectionB">
      <div class="container">
        <div class="sec-title">{{ navBarList[1] }}</div>
        <div class="content">
          <div class="imgBox">
            <img
              src="https://www.dtwave.com/images/solution/dc/framework/framework.png"
              alt=""
            />
          </div>
          <div class="info">
            <div class="intro">
              数智地产解决方案，依托数据中台底层数据建设框架内容，通过对企业数据，数据开发及治理的技术实施，抓取数据资产价值亮点，结合地产行业业务特性；盘点地产企业客户数据价值、地产项目开发、企业运营数据等，从而拓展出地产行业相关业务应用三大体系，解决地产行业各企业客户运营数据化管理、企业数字风险预警管控及地产企业投资管理等，全链路数字化经营管理的战略性应用难题。
            </div>
            <div class="btn">联系我们</div>
            <div class="sub-title">解决方案</div>
            <div class="list">
              <div class="item">
                重塑企业客户数据运营体系，建立客户运营数据服务平台，帮助房企梳理规范企业客户数据且实现客户数据资产复用。
              </div>
              <div class="item">
                根据企业内部风控管理体系框架，为企业搭建一个自动化、线上化地产风控审计平台，提高企业审计效率，降低企业审计管理风险。
              </div>
            </div>
            <div class="sub-title">关联产品</div>
            <div class="product-link">
              <div class="item">
                <img
                  src="https://www.dtwave.com/images/deepwave/product/kehushuzi.svg"
                  alt=""
                />
                <div class="name">客户数字运营平台</div>
              </div>
              <div class="item">
                <img
                  src="https://www.dtwave.com/images/deepwave/product/zhihuishenji.svg"
                  alt=""
                />
                <div class="name">智慧审计风控平台</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container" ref="sectionC">
      <section class="sectionC">
        <div class="sec-title">{{ navBarList[2] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionCList" :key="index">
            <div class="imgBox">
              <img :src="item.img" alt="" />
            </div>
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="list">
                <div
                  class="list-item"
                  v-for="(item_s, index_s) in item.desc"
                  :key="index_s"
                >
                  {{ item_s }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="sectionD" ref="sectionD">
      <div class="container">
        <div class="sec-title">{{ navBarList[3] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionDList" :key="index">
            <img :src="item.img" alt="" />
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="list">
                <div
                  class="list-item"
                  v-for="(item_s, index_s) in item.desc"
                  :key="index_s"
                >
                  {{ item_s }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container" ref="sectionE">
      <section class="sectionE">
        <div class="sec-title">{{ navBarList[4] }}</div>
        <div class="content">
          <div class="top">
            <img
              src="https://www.dtwave.com/images/logo/94_94/wanyi.svg"
              alt=""
            />
            <div class="name">万翼科技</div>
            <div class="send">立即咨询</div>
          </div>
          <div class="list">
            <div class="list-item">
              <img src="https://www.dtwave.com/images/other/bjsm.svg" alt="" />
              <div class="info">
                <div class="title">背景说明</div>
                <div class="desc">
                  随着信息化程度不断地完善和全面，集团决定启动数据中台战略，期望通过数据中台建立起大数据的能力，破数据孤岛，激活数据生命力，并不断地为各部门、各区域公司、各业态板块赋能，打造良性的数据生态。
                </div>
              </div>
            </div>
            <div class="list-item">
              <img src="https://www.dtwave.com/images/other/jzsm.svg" alt="" />
              <div class="info">
                <div class="title">价值说明</div>
                <div class="desc">
                  数澜结合自身数据中台建设服务能力，分析集团当前的数据平台和资产情况，制定了合理的实施路线，将整体建设过程分成搭平台，做服务、优算法，建能力、挖价值，助服务三个步骤推进，为全集团各业务部门、各业务线、各区域业务赋能。
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="contactus">
      <div class="title">从这里开始，让数据用起来</div>
      <div class="btn">联系我们</div>
    </div>
    <Foot />
  </div>
</template>
<script>
export default {
  data() {
    return {
      bannerImg: require("@/assets/solution/pic_banner_gongchang.png"),
      navBarList: ["行业痛点", "方案架构", "方案优势", "价值场景", "客户案例"],
      activeIndex: 0,
      sectionAList: [
        {
          img: "https://www.dtwave.com/images/solution/dc/painPoint/p1.svg",
          title: "传统地产企业运营成本增加",
          desc: "地产行业调控常态化，开发利润走低，传统运营模式受阻，运营成本增加",
        },
        {
          img: "https://www.dtwave.com/images/solution/dc/painPoint/p2.svg",
          title: "跨业态发展运营难度加大",
          desc: "企业跨界多业态发展，内部组织运营能力要求增加，业务板块资源割裂不宜跨界融合上升",
        },
        {
          img: "https://www.dtwave.com/images/solution/dc/painPoint/p3.svg",
          title: "数字智能串联管理",
          desc: "大数据、人工智能等系统设备独立分布，如何将各智能应用终端“围”我所用，统一调度管理",
        },
        {
          img: "https://www.dtwave.com/images/solution/dc/painPoint/p4.svg",
          title: "存量资产运营",
          desc: "企业规模扩张，转型升级寻求新增长点，存量资产如何发挥其价值",
        },
      ],
      sectionCList: [
        {
          img: "https://www.dtwave.com/images/solution/dc/advantage/a1.png",
          title: "高度成熟数据资产构建工具",
          desc: [
            "多源异构自动适配",
            "数据开发支持数据资产构建",
            "全面的数据资产管理能力",
          ],
        },
        {
          img: "https://www.dtwave.com/images/solution/dc/advantage/a2.png",
          title: "企业数据资产场景化",
          desc: ["客户大运营", "开发大运营", "企业风险管控"],
        },
        {
          img: "https://www.dtwave.com/images/solution/dc/advantage/a3.png",
          title: "行业实践",
          desc: [
            "20+头部房企数字化实践案例",
            "房企数智化落地方案与实操",
            "地产10大条线业务标准数据资产沉淀",
          ],
        },
        {
          img: "https://www.dtwave.com/images/solution/dc/advantage/a4.png",
          title: "全面房地产数智化服务能力",
          desc: [
            "数据资产场景化咨询服务",
            "数据资产应用工具产品",
            "地产数智业务创新设计",
          ],
        },
      ],
      sectionDList: [
        {
          img: "https://www.dtwave.com/images/solution/dc/scene/s1.jpg",
          title: "客户大运营体系",
          desc: [
            "通过专业的标签体系构建方法轮，面向地产全域客户（流量、访客、业主、会员）构建起全域客户的数据资产。",
            "针对企业客户数据资源，形成客户画像，进而辅助相关的业务，形成数据支撑，如高意向客户识别，精准营销、客服、交叉营销等。",
            "构建企业的私域客户资源池，形成有针对性的客户运营策略。",
          ],
        },
        {
          img: "https://www.dtwave.com/images/solution/dc/scene/s2.jpg",
          title: "开发大运营体系",
          desc: [
            "基于项目开发各流程环节数据，为投资、设计、销售、货值供应、经营分析等环节提供数据支撑。",
            "实现房企全域经营指标的标准口径统一，保证房企各部门各专业各层级对核心经营指标认知一致性。",
            "基于大运营体系的构建起精细化管理模式，通过数据流通，信息共享，实现个业务条线的大协同，减少管理冗余，实现降本增效。",
          ],
        },
        {
          img: "https://www.dtwave.com/images/solution/dc/scene/s3.jpg",
          title: "地产风控体系",
          desc: [
            "通过大数据实现全量审计，完善审计集成化、标准化、实时化、规范化流程闭环。",
            "全域风险预警：覆盖企业全业务场景，实现主动风控管理。",
            "全流程在线作业：可根据企业需求，配置企业业务节点，符合各业务场景。",
            "高复用知识库：行业内外知名案例及整个系统的知识复用。",
            "敏捷风控引擎：为风控部门提供敏捷、高效、可验证的风险管控工具。",
          ],
        },
      ],
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 0;
        }
      });
    }, options);

    observer1.observe(this.$refs.sectionA);

    const observer2 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 1;
        }
      });
    }, options);

    observer2.observe(this.$refs.sectionB);

    const observer3 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 2;
        }
      });
    }, options);

    observer3.observe(this.$refs.sectionC);

    const observer4 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 3;
        }
      });
    }, options);

    observer4.observe(this.$refs.sectionD);
    const observer5 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 4;
        }
      });
    }, options);

    observer5.observe(this.$refs.sectionE);
  },
  methods: {
    changeActiveIndex(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          this.$refs.sectionA.scrollIntoView({ behavior: "smooth" });
          break;
        case 1:
          this.$refs.sectionB.scrollIntoView({ behavior: "smooth" });
          break;
        case 2:
          this.$refs.sectionC.scrollIntoView({ behavior: "smooth" });
          break;
        case 3:
          this.$refs.sectionD.scrollIntoView({ behavior: "smooth" });
          break;
        case 4:
          this.$refs.sectionE.scrollIntoView({ behavior: "smooth" });
          break;
      }
    },
    changeSectionC(index) {
      this.sectionCActiveIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1280px;
  margin: 0 auto;
}
.projectPage {
  .navBar {
    height: 55px;
    position: sticky;
    z-index: 100;
    top: 0;
    background-color: #fff;
    box-shadow: 0 1px 1px 0 #ebedf6;
    > .container {
      display: flex;
      align-items: center;
      .item {
        cursor: pointer;
        margin-right: 50px;
        font-size: 16px;
        line-height: 55px;
        color: #7a8ba6;
        position: relative;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background-image: linear-gradient(90deg, #659eff 0, #2466ff 100%);
          position: absolute;
          bottom: 0;
          left: 0;
          opacity: 0;
          transition: all 0.3s;
        }
      }
      .item.active {
        &::after {
          opacity: 1;
        }
      }
    }
  }
  section {
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      width: 100%;
      padding-bottom: 72px;
      padding-top: 72px;
    }
  }
  .sectionA {
    width: 100%;
    padding-bottom: 80px;
    .content {
      display: flex;
      justify-content: space-between;
      .item {
        flex: 1;
        img {
          width: 40px;
          height: 40px;
          margin-top: 7px;
        }
        .title {
          width: 100%;
          margin-top: 32px;
          line-height: 32px;
          height: 36px;
          font-size: 18px;
          color: #374567;
          font-weight: 500;
        }
        .desc {
          margin-top: 14px;
          font-size: 14px;
          color: #7a8ba6;
          line-height: 24px;
          text-align: justify;
        }
        & + .item {
          margin-left: 96px;
        }
      }
    }
  }
  .sectionB {
    width: 100%;
    background-color: #f9faff;
    padding-bottom: 80px;
    .content {
      display: flex;
      height: 720px;
      .imgBox {
        width: 728px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #eff2ff;
        img {
          width: 712px;
          height: 704px;
        }
      }
      .info {
        flex: 1;
        height: 100%;
        background-color: #fff;
        .intro {
          margin-right: 40px;
          margin-left: 40px;
          margin-top: 48px;
          text-align: justify;
          line-height: 24px;
          font-size: 14px;
          color: #7a8ba6;
        }
        .btn {
          margin-left: 40px;
          margin-top: 16px;
          border-radius: 2px;
          background-image: linear-gradient(90deg, #659eff 0, #2466ff 100%);
          line-height: 36px;
          width: 108px;
          height: 36px;
          text-align: center;
          cursor: pointer;
          color: #fff;
          font-size: 14px;
        }
        .sub-title {
          margin-top: 32px;
          font-weight: 500;
          margin-left: 40px;
          margin-right: 40px;
          color: #374567;
          font-size: 16px;
          line-height: 28px;
        }
        .list {
          width: 100%;
          .item {
            width: 447px;
            line-height: 24px;
            font-size: 14px;
            color: #7a8ba6;
            float: left;
            text-align: justify;
            margin-left: 72px;
            margin-top: 8px;
            position: relative;
            &::before {
              content: "";
              width: 12px;
              height: 10px;
              background-image: url("https://www.dtwave.com/images/other/gou.svg");
              background-size: 100% 100%;
              background-repeat: no-repeat;
              position: absolute;
              top: 8px;
              left: -25px;
            }
          }
        }
        .product-link {
          display: flex;
          margin-top: 8px;
          margin-left: 40px;
          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 134px;
            height: 90px;
            border: 1px solid #eff2ff;
            cursor: pointer;
            transition: all 0.3s;
            &:hover {
              border: 1px solid #2466ff;
            }
            & + .item {
              margin-left: 16px;
            }
            img {
              width: 24px;
              height: 24px;
            }
            .name {
              margin-top: 15px;
              font-size: 14px;
              color: #374567;
              padding-left: 10px;
              font-weight: 400;
              padding-right: 10px;
              height: 24px;
              width: 100%;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .sectionC {
    width: 100%;
    padding-bottom: 80px;
    .content {
      display: grid;
      column-gap: 24px;
      row-gap: 24px;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 272px 272px;
      .item {
        background: #f9faff;
        display: flex;
        .imgBox {
          width: 247px;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          .title {
            font-size: 16px;
            color: #374567;
            margin-top: 45px;
            margin-bottom: 24px;
            font-weight: 500;
          }
          .list {
            .list-item {
              font-size: 14px;
              margin-left: 13px;
              text-align: justify;
              width: 340px;
              line-height: 24px;
              color: #374576;
              margin-bottom: 20px;
              position: relative;
              &::before {
                content: "";
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-image: linear-gradient(
                  90deg,
                  #659eff 0,
                  #2466ff 100%
                );
                left: -13px;
                top: 9px;
                position: absolute;
              }
            }
          }
        }
      }
    }
  }
  .sectionD {
    width: 100%;
    background-color: #f9faff;
    padding-bottom: 80px;
    .content {
      .item {
        height: 456px;
        display: flex;
        justify-content: space-between;
        & + .item {
          margin-top: 80px;
        }
        &:nth-of-type(even) {
          flex-direction: row-reverse;
        }
        img {
          width: 728px;
          height: 100%;
        }
        .info {
          flex: 1;
          height: 100%;
          background-color: #fff;
          .title {
            font-size: 16px;
            height: 24px;
            font-weight: 500;
            line-height: 24px;
            color: #374567;
            margin-top: 40px;
            margin-left: 40px;
            margin-bottom: 24px;
          }
          .list {
            .list-item {
              font-size: 14px;
              float: left;
              line-height: 24px;
              color: #374567;
              width: 443px;
              text-align: justify;
              margin-bottom: 24px;
              width: 459px;
              position: relative;
              margin-left: 55px;
              &::before {
                content: "";
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: linear-gradient(90deg, #659eff 0, #2466ff 100%);
                position: absolute;
                top: 9px;
                left: -15px;
              }
            }
          }
        }
      }
    }
  }
  .sectionE {
    width: 100%;
    padding-bottom: 80px;
    .content {
      border: 1px solid #dee4f3;
      .top {
        height: 160px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 30px 0 33px;
        border-bottom: 1px solid #dee4f3;
        img {
          background: #fff;
          border: 1px solid #ebf0fc;
          box-shadow: 0 5px 8px 0 rgba(235, 237, 246, 0.9);
          border-radius: 8px;
          width: 96px;
          height: 96px;
          margin-right: 33px;
        }
        .name {
          flex: 1;
          font-size: 18px;
          color: #374567;
          line-height: 32px;
          font-weight: 500;
          transform: translateY(-70%);
        }
        .send {
          font-size: 16px;
          line-height: 22px;
          height: 22px;
          color: #2466ff;
          cursor: pointer;
          padding-left: 20px;
          margin-left: 50px;
          transform: translateY(-70%);
          position: relative;
          &::before {
            content: "";
            width: 16px;
            height: 16px;
            background-image: url("https://www.dtwave.com/images/other/ljzx.svg");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: -7px;
          }
        }
      }
      .list {
        padding: 32px 40px 32px 33px;
        background-color: #fcfdff;
        .list-item {
          display: flex;
          & + .list-item {
            margin-top: 32px;
          }
          img {
            width: 24px;
            height: 24px;
            margin-right: 16px;
            transform: translateY(4px);
          }
          .info {
            .title {
              font-size: 18px;
              line-height: 32px;
              height: 32px;
              color: #374567;
            }
            .desc {
              margin-top: 8px;
              font-size: 14px;
              color: #7a8ba6;
              max-height: 48px;
              line-height: 24px;
              margin-left: 16px;
              position: relative;
              &::before {
                content: "";
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background-image: linear-gradient(
                  90deg,
                  #659eff 0,
                  #2466ff 100%
                );
                position: absolute;
                top: 9px;
                left: -16px;
              }
            }
          }
        }
      }
    }
  }
  > .contactus {
    width: 100%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url("https://www.dtwave.com/images/styl/bg_form.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .title {
      font-size: 30px;
      line-height: 40px;
      letter-spacing: 1.88px;
      text-align: center;
      color: #fff;
      padding-top: 49px;
      font-weight: 500;
    }
    .btn {
      margin-top: 20px;
      width: 108px;
      height: 36px;
      border-radius: 2px;
      background-color: #fff;
      margin: 20px auto;
      font-size: 14px;
      color: #2466ff;
      line-height: 36px;
      cursor: pointer;
      text-align: center;
    }
  }
}
</style>